import { useState as c, useEffect as r } from "react";
const u = (s) => {
  const [e, t] = c(s);
  return r(() => {
    const o = document.querySelector("html");
    o && (o.style.overflow = e ? "hidden" : "auto");
  }, [t, e]), t;
};
export {
  u as useSetBodyScroll
};
//# sourceMappingURL=useSetBodyScroll.mjs.map
